import { render } from "./WatcherExample.vue?vue&type=template&id=73cf572a"
import script from "./WatcherExample.vue?vue&type=script&lang=js"
export * from "./WatcherExample.vue?vue&type=script&lang=js"
script.render = render

export default script